import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CertificationService } from '../services/certification.service';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { CaptchaVM } from '../models/captchaVM';
import { AppSettings } from '../../shared/configuration/appsettings.config';

@Component({
    selector: 'app-disclaimer',
    templateUrl: './disclaimer.component.html'
})

export class DisclaimerComponent implements OnInit {

    imgCaptchaSource: string;
    confirmCaptchaCode: string;
    isValidCaptchaInput: boolean;
    submitted: boolean;
    frmDisclaimer: UntypedFormGroup;
    errorCollection: any[];
    responseErrorMessage: string;
    disclaimerIntro: string;
    dislaimerLogoUrl: string;
    disclaimerTitle: string;

    constructor(private fb: UntypedFormBuilder, private certificationService: CertificationService, private router: Router, private title: Title) {

        this.title.setTitle('Tax Certification Portal Disclaimer')
    }

    ngOnInit() {
        this.initForm();
        this.generateCaptcha();
        this.loadContent();
    }

    get fc() {
        return this.frmDisclaimer.controls;
    }

    private initForm() {
        this.frmDisclaimer = this.fb.group({
            'confirmCaptchaCode': new UntypedFormControl(null)
        });
    }

    private clearUIErrors() {

        this.errorCollection = [];
    }

    private loadContent() {
        let refCode: string = AppSettings.getReferenceCode();
        this.certificationService.getDisclaimerContent(refCode)
            .subscribe((response: any) => {
                this.disclaimerIntro = response.disclaimerIntro;
                this.disclaimerTitle = response.title;
                this.dislaimerLogoUrl = response.brandLogoUrl;
            });
    }

    private generateCaptcha() {

        this.certificationService.generateCaptchaToMemory()
            .subscribe(o => {
                this.imgCaptchaSource = o.captchaImageSource;
            },
                err => {
                    console.log(err.error);
                });
    }

    // This is the animation on focus/blur on textboxes
    public focusIn(target: HTMLElement): void {
        target.parentElement.classList.add('e-input-focus');
    }

    public focusOut(target: HTMLElement): void {
        target.parentElement.classList.remove('e-input-focus');
    }

    submitAgree() {
        this.clearUIErrors();
        this.submitted = true;

        let captcha: CaptchaVM = {
            confirmCaptchaCode: this.fc.confirmCaptchaCode.value
        };

        this.certificationService.disclaimerAgree(captcha)
            .subscribe((response: any) => {
                if (response.valid) {


                    sessionStorage.setItem('captcha', '1');
                    this.router.navigate(['welcome']);
                }

            },
                (err) => {
                    this.errorCollection = err;
                });
    }
}

